import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=3f10d7fc&scoped=true"
import script from "./invitations.vue?vue&type=script&lang=js"
export * from "./invitations.vue?vue&type=script&lang=js"
import style0 from "./invitations.vue?vue&type=style&index=0&id=3f10d7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10d7fc",
  null
  
)

export default component.exports